import "./home.css";
import { useState } from "react";
import { sliderData } from "../../data/SliderData";
import Slider from "../../components/slider/Slider";
import ServiceCategories from "../../components/service-categories/ServiceCategories";
import PartnerCompanies from "../../components/partners-companies/PartnerCompanies";
import BlogsSlider from "../../components/blogs-slider/BlogsSlider";

function Home() {
  const [sliderIndex, setSliderIndex] = useState(0);

  const slider = sliderData[sliderIndex];

  return (
    <div className="home">
      {/* Slider Section */}
      <div className="slider-section">
        <Slider
          data={slider}
          dataLength={sliderData.length}
          setSliderIndex={setSliderIndex}
        />
      </div>

      {/* Services Section */}
      <div className="our-services-section">
        <div className="our-services-section-header">
          <h1>
            <span className="bold">Our</span> Services
          </h1>
          <div className="our-services-section-header-border"></div>
        </div>

        <div className="our-services-categories">
          <ServiceCategories />
        </div>
      </div>

      {/* Partner Companies Section */}
      <PartnerCompanies />

      {/* News & Events Section */}
      <BlogsSlider />
    </div>
  );
}

export default Home;
